<template>
    <div class="external-template__preview">
        <model-icon
            :url="$props.externalModel.img"
            :default-image="selectedEngine.image"
        />

        <h3 class="title">
            {{$props.externalModel.name}}
        </h3>

        <span class="engine">
            {{selectedEngine.label}}
        </span>

        <p
            v-if="$props.externalModel.description"
            class="description"
        >
            {{$props.externalModel.description}}
        </p>

        <div class="actions">
            <delete-model-btn
                :modal-title="$t('model.external-model.preview-external-model.deleteExternalModel')"
                @delete="$emit('delete')"
                :is-deleting="$props.isDeleting"
            />

            <or-button
                buttonType="button"
                type="primary"
                class="change-engine--btn"
                color="primary"

                @click="$emit('edit')"
            >
              {{ $t('generic.edit') }}
            </or-button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { meta_limits as metaLimits } from '@/modules/limits'
import ModelIcon from '../common/model_icon'
import DeleteModelBtn from '../common/delete-model-button'

export default {
  components: {
    ModelIcon,
    DeleteModelBtn
  },

  props: {
    externalModel: Object,
    isDeleting: Boolean
  },

  computed: {
    ...mapState('knowledgebase/customModels', ['customEngines']),

    titleMax () {
      return metaLimits ? metaLimits.title.max : 0
    },

    selectedEngine () {
      const engine = this.customEngines.find(engine => engine.id === this.$props.externalModel.engine)
      return engine || {}
    }
  }
}
</script>

<style lang="scss" scoped>
    .external-template__preview {
        margin-top: 30px;
    }

    .title {
        margin-bottom: 8px;
        font-size: 18px;
        line-height: 27px;
        font-weight: bold;
    }

    .engine {
        font-size: 14px;
        font-weight: normal;
        color: rgb(145, 150, 157);
    }

    .description {
        overflow: hidden;
        text-overflow: ellipsis;

        margin-top: 16px;
        color: rgb(30, 35, 43);
        font-size: 14px;
        font-weight: normal;
        line-height: 21px;
        word-break: break-all;
    }

    .actions {
        display: flex;
        justify-content: space-between;
        margin-top: 32px;
        .change-engine--btn {
            margin-left: 25px;
        }
    }
</style>
